let is_authenticated = false;
if (localStorage.getItem('api_access_token') && localStorage.getItem('api_access_token') !== '') {
    is_authenticated = true;
} else {
    is_authenticated = false;
}
export const check_access_token = is_authenticated;
